import { useEffect } from 'react';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

import useAuth from './useAuth';
import { useQueryClient } from '@tanstack/react-query';
import { notificationsKey } from '../queries/notifications';
import { baseURL, HUB_ENV, HUB_URL } from 'utils/axios';

function useAppointmentsNotification(): void {
  const { user: loggedInUser } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(`${HUB_URL}/hub/${HUB_ENV}/shwra`)
      .configureLogging(LogLevel.Information)
      .build();

    connection.start().then(() => {
      if (!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        Notification.requestPermission().then((permission) => {
          connection.on('General', (user) => {
            console.log(user, 'isUser');
            if (loggedInUser?.id === user?.userId) {
              console.log('called');
              queryClient.invalidateQueries([notificationsKey]).then();
              if (permission === 'granted') {
                new Notification('شورى', {
                  body: user.message,
                  icon: '/favicon/mstile-144x144.png'
                });
              }
              queryClient.invalidateQueries([notificationsKey]).then();
            }
          });
          connection.on('NotifyOnAddAppointment', (user) => {
            if (loggedInUser?.id === user?.userId) {
              if (permission === 'granted') {
                new Notification('شورى', {
                  body: user.message,
                  icon: '/favicon/mstile-144x144.png'
                });
              }
              queryClient.invalidateQueries([notificationsKey]).then();
            }
          });
          connection.on('NotifyForUpcomingAppointment', (user) => {
            if (loggedInUser?.id === user?.userId) {
              if (permission === 'granted') {
                new Notification('شورى', {
                  body: user.message,
                  icon: '/favicon/mstile-144x144.png'
                });
              }
              queryClient.invalidateQueries([notificationsKey]).then();
            }
          });
        });
      } else {
        connection.on('General', (user) => {
          console.log(user, 'isUser');
          if (loggedInUser?.id === user?.userId) {
            queryClient.invalidateQueries([notificationsKey]).then();
          }
        });
        connection.on('NotifyOnAddAppointment', (user) => {
          if (loggedInUser?.id === user?.userId) {
            queryClient.invalidateQueries([notificationsKey]).then();
          }
        });
        connection.on('NotifyForUpcomingAppointment', (user) => {
          if (loggedInUser?.id === user?.userId) {
            queryClient.invalidateQueries([notificationsKey]).then();
          }
        });
      }
    });

    return () => {
      connection.stop().then();
    };
    // eslint-disable-next-line
  }, []);
}
export default useAppointmentsNotification;
